<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.8065 3.02648C1.5465 2.76648 1.5465 2.34648 1.8065 2.08648C2.0665 1.82648 2.49317 1.82648 2.75317 2.08648L13.6265 12.9731C13.8865 13.2331 13.8865 13.6531 13.6265 13.9131C13.3665 14.1731 12.9465 14.1731 12.6865 13.9131L10.8732 12.0998C9.97984 12.4465 9.01317 12.6465 7.99984 12.6465C4.6665 12.6465 1.81984 10.5731 0.666504 7.64648C1.17984 6.33315 2.03984 5.19981 3.11984 4.33981L1.8065 3.02648ZM11.3331 7.64638C11.3331 5.80638 9.83972 4.31304 7.99972 4.31304C7.65972 4.31304 7.33305 4.37971 7.01972 4.47304L5.57305 3.02638C6.33972 2.77971 7.15305 2.64638 7.99972 2.64638C11.3331 2.64638 14.1797 4.71971 15.3331 7.63971C14.8731 8.81304 14.1397 9.83971 13.2131 10.6597L11.1731 8.61971C11.2664 8.31304 11.3331 7.98638 11.3331 7.64638ZM7.99984 10.9799C6.15984 10.9799 4.6665 9.48658 4.6665 7.64658C4.6665 7.13325 4.7865 6.64658 4.99317 6.21992L6.03984 7.26658C6.01984 7.38658 5.99984 7.51325 5.99984 7.64658C5.99984 8.75325 6.89317 9.64658 7.99984 9.64658C8.13317 9.64658 8.25317 9.62658 8.37984 9.59992L9.4265 10.6466C8.99317 10.8599 8.51317 10.9799 7.99984 10.9799ZM9.97981 7.42661C9.87981 6.49328 9.14648 5.76661 8.21981 5.66661L9.97981 7.42661Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
